import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import ru from "./locales/ru.json";
import kk from "./locales/kk.json";

export const supportedLanguages = [
    {code: "ru", label: "Рус"},
    {code: "kk", label: "Қаз"},
    {code: "en", label: "Eng"},
] as const;

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: en,
            },
            ru: {
                translation: ru,
            },
            kk: {
                translation: kk,
            },
        },
        fallbackLng: "ru",
        supportedLngs: ["ru", "kk", "en"],

        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "i18nextLng",
        },

        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;